import { createContext, useContext } from "react";

import type { AssetApiClient } from "@skilitics/asset-register-api-client";
export type AssetApiContext = { api: AssetApiClient };

export const AssetApiContext = createContext<AssetApiContext | undefined>(undefined);
AssetApiContext.displayName = "AssetApiContext";

export const useAssetApi = (): AssetApiClient => {
  const context = useContext(AssetApiContext);
  if (!context) {
    throw new Error(`Expected AssetApiProvider in component tree.`);
  }
  return context.api;
};
